import SummaryEdit from '../../components/SummaryEdit';
import { CardMode } from 'txp-data/lib/schema/viewSchema/CardMode';
import TxpDataRow from 'txp-data/lib/schema/viewSchema/TxpDataRow';

/**
 * returns the Summary Edit control
 */

export default function getSummaryEditControl(
    cardMode: CardMode,
    readOnlyLines: TxpDataRow[],
    editableField: string,
    editableData: TxpDataRow,
    onTextChanged?: (value: string) => void
): JSX.Element {
    return SummaryEdit({
        cardMode: cardMode,
        readOnlyLines: readOnlyLines,
        editableField: editableField,
        editableData: editableData,
        onTextChanged: onTextChanged,
    });
}
